if(!customElements.get('quick-buy-compact')) {
  customElements.define('quick-buy-compact', class QuickBuyCompact extends HTMLElement {
    constructor() {
      super();
      this.variants = this.querySelectorAll('[data-variant-id]');
      if(this.variants.length === 0) return;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    connectedCallback() {
       this.variants.forEach(variant => variant.addEventListener('click', () => this.handleAddToCart(variant)));
    }

    async handleAddToCart(variant) {
      event.preventDefault();
      const variantID = variant?.dataset?.variantId;
      console.log(variantID);
      
      if(variant.getAttribute('aria-disabled') === 'true' || !variantID) return;
      try {
        variant.setAttribute('aria-disabled', true);
        variant.classList.add('loading');
        variant.querySelector('.loading__spinner').classList.remove('hidden');
        this.handleErrorMessage();
        const url = `${window.Shopify.routes.root}cart/add.js`;
        const variantData = {
          items: [
            {
              id: variantID,
              quantity: 1
            }
          ]
        }
        if(this.cart) {
          variantData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          variantData.sections_url = window.location.pathname;
        }
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(variantData)
        }

        const response = await fetch(url, config);
        const result = await response.json();
        if (result.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'quick-buy-compact',
            productVariantId: variantID,
            errors: result.errors || result.description,
            message: result.message,
          });
          this.handleErrorMessage(response.description);
         variant.classList.add('sold-out');
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'quick-buy-compact',
            productVariantId: variantID,
            cartData: result,
          });
          variant.classList.remove('loading');
          variant.removeAttribute('aria-disabled');
          if(this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          variant.querySelector('.loading__spinner').classList.add('hidden');
          setTimeout(()=> {
            this.classList.remove('open');
            this.cart.renderContents(result);
          }, 150)
        }
      } catch (error) {
        console.error(error);
      }
    }

    handleErrorMessage(errorMessage = false) {
      const errorMessageContainer = this.querySelector('.error-message');
      if (!errorMessageContainer) return;
      if(!errorMessage) {
        errorMessageContainer.classList.add('hidden');
      } else {
        errorMessageContainer.textContent = errorMessage;
        errorMessageContainer.classList.remove('hidden');
      }
    }
  })
}